import React from "react";
import "./Ourteam.css";
import TeamMember from "./OurTeamprops";

export default function OurTeam() {
  return (
    <div className="AllTeamMembers">
      <h1>FACULTY COORDINATORS</h1>

      <div className="myteam">
        <TeamMember
          position="Convenor"
          name="Mr.M.Shravan Kumar"
          contact="+91 9100000024"
        />

        <div className="Orderwise">
          <TeamMember
            position="Co-Convenor"
            name="Mr.B.Anil Kumar"
            contact="+91 9100000023"
          />
          <TeamMember
            position="Co-Convenor"
            name="Mr.P.Venu Madhav"
            contact="+91 9100000906"
          />
          <TeamMember
            position="Co-Convenor"
            name="Mr.U.Rajender"
            contact="+91 9100000020"
          />
        </div>
        <h1>STUDENT COORDINATORS</h1>
        <div className="sacOrderWise">
          <TeamMember
            position="SAC President"
            name="Mr. Vasisht Boddula"
            contact="+91 8639201215"
          />
          <TeamMember
            position="SAC Safety President"
            name="Mr.Dheeraz Sai,"
            contact="+91 9848991379"
          />
        </div>

        <div className="Orderwise">
          <TeamMember
            position="SAC PRO"
            name="Mr.Giridhar Reddy"
            contact="+ 91 9100662054"
          />
          <TeamMember
            position="SAC PRO"
            name="Mr.Giridhar Reddy"
            contact="+ 91 9100662054"
          />
          <TeamMember
            position="SAC PRO"
            name="Mr.Giridhar Reddy"
            contact="+ 91 9100662054"
          />
        </div>
      </div>
    </div>
  );
}
